var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonPeriod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fillRule: "nonzero"
    },
    d: "M38,26l8,0m-36,-4l-8,0m20,18l4,0l0,-32l-4,0l0,32Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M30,22l0,4l8,0l0,6l8,-8l-8,-8l0,6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M18,26l0,-4l-8,0l0,-6l-8,8l8,8l0,-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonPeriod);
export default __webpack_public_path__ + "static/media/comparison-period.2b1c847eecf50eb635fe9f6bf9383233.svg";
export { ForwardRef as ReactComponent };